import { useMemo } from 'react';
import type { ColorScheme } from '@cbhq/cds-common/core/theme';
import { useTheme } from '@cbhq/cds-web/hooks/useTheme';

import { Application } from '../providers/Applications.types';

export function applicationSourceImage(spectrum: ColorScheme, application?: Application) {
  const { illustrationUrl, tileUrls } = application ?? {};

  if (!spectrum) {
    return illustrationUrl;
  }

  return tileUrls?.[spectrum] ?? illustrationUrl;
}

export function useApplicationSourceImage(application?: Application) {
  const { activeColorScheme: spectrum } = useTheme();

  const sourceImage = useMemo(() => {
    return applicationSourceImage(spectrum, application);
  }, [application, spectrum]);

  return sourceImage;
}
